const { $ } = window

export default {
	init() {
      // gsap.registerPlugin(ScrollTrigger)
		generatePageNav()

      // const tl = gsap.timeline({
      //    defaults: {
      //       duration: 0.2,
      //       ease:'power1.out',
      //       opacity: 0,
      //    },
      //    // scrollTrigger: {},
      // })
      // tl.from('.update-contact', {})
      //    .from('.hero-tos-content h1', {y: -16})
      //    .from('.hero-tos-content h1 ~ *', {x:16}, '-=0.2')
      //    .from('aside', {y:16}, '+=0.2')
      //    .from('aside a:not(:first-child)', {y:16, stagger: 0.05})//, '+=0.2') //!
      // $('h2').each((_idx, el) => gsap.from(el, { delay: 0.2, opacity: 0, y: -16, scrollTrigger: { trigger: el, start: 'top 96%'}}))
      // $('article p').each((_idx, el) => gsap.from(el, { opacity: 0, x: 16, scrollTrigger: { trigger: el, start: 'top 90%'}}))
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}


// vanilla
// padding addition to top of scroll position
// @see https://stackoverflow.com/questions/38069213/add-padding-top-to-scroll-when-using-href-id
export function generatePageNav() {
   // return
   const nav = document.querySelector('.single-pillars__nav__ul')
   const h2s = document.querySelectorAll( '.page-template-legal__content h2, .single-pillars-pages__content h2, .single-pillars-pages__content h3' ); //25-icebreakers-to-introduce-yourself-to-a-new-classroom has h3s
   if (!h2s.length) return
   h2s.forEach((h2) => {
      let li = document.createElement('li')
      let a = document.createElement('a')
      a.innerText = h2.innerText
      const id = h2.innerText.toLowerCase().replace(/\s+/g, '-')
      h2.id = id
      a.id = id + '-anchor'
      a.href = `#${id}`
      a.classList.add('tos-nav-link')
      li.appendChild(a)
      nav.appendChild(li)
   })

   let enableScrolling = false;
   setTimeout(() => { enableScrolling = true;}, 1000) //workaround for 
   let activeId = location.hash.substr( 1 ); //todo: deprecated substr method
   const targetH2 = document.querySelector( `.page-template-legal__content h2[id="${ activeId }"], .single-pillars-pages__content h2[id="${ activeId }"]` )
   // switch out false ID for first h2 ID
   // update URL if necessary - scrolls
   if ( 
      activeId && ! targetH2
   ) {
      activeId = h2s[ 0 ].id; 
      const url = new URL( location.href );
      console.log(url)
      url.hash = activeId;
      history.replaceState( null, '', url );
   }
   // set first item as active if not hash
   if ( 
      ! activeId
   ) { 
      activeId = h2s[ 0 ].id; 
   }
   // let navAnchors = document.querySelectorAll('.tos-nav-link')
   let inPageNavAnchors = Array.from(document.querySelectorAll('.tos-nav-link'));
   let activeAnchor = document.querySelector( `a[id="${ activeId }-anchor"]` );
   activeAnchor.classList.add( 'active' );
   document.onscroll = () => {
      if ( enableScrolling ) {
         // for ( const h2 of h2s ) {
         for (let i = h2s.length - 1; i >= 0; i--) {
            const h2 = h2s[i];
            if ( window.innerHeight / 2 > h2.getBoundingClientRect().bottom ) {
               if ( ! activeId.includes( h2.id ) ) {
                  inPageNavAnchors.map( ( item ) => {
                     item.classList.remove( 'active' ) 
                  });
                  activeId = h2.id;
                  activeAnchor = document.querySelector(
                     `a[id="${ activeId }-anchor"]`
                  );
                  activeAnchor.classList.add( 'active' );
                  $('.single-pillars__nav__button span').text(activeAnchor.innerText)
               }
               break;
            }
         }
      }
   };

   let t
   $(inPageNavAnchors).click((e) => {
      // console.log(e.target)
      // clearInterval(t)
      enableScrolling = false
      $(inPageNavAnchors).removeClass('active')
      // this.classList.add('active')
      e.target.classList.add('active')
      let t = setTimeout( () => {
         enableScrolling = true;
      }, 1000 );
   })

   $('.single-pillars__nav__button').on('click', function() {
      this.closest('.tos-page-nav').classList.toggle('single-pillars__nav--open')
   })
   
   //mobile
   $('.single-pillars__nav__ul li').on('click', function() {
      this.closest('.tos-page-nav').classList.remove('single-pillars__nav--open')
      document.querySelector('.single-pillars__nav__button span').innerText = this.innerText
   })

   //if click outside of nav, close it
   $(document).on('click', function(event) {
      if (!$(event.target).closest('.tos-page-nav').length) {
         if ($('.tos-page-nav').hasClass('single-pillars__nav--open')) {
            $('.tos-page-nav').removeClass('single-pillars__nav--open')
         }
      }
   })

}
